export default "__VITE_ASSET__ebe7cabe__"